<template>
    <v-menu offset-y light v-model="isMenuOpened" v-if="loggedIn">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                style="letter-spacing: 0.0292857143em; text-transform: unset;"
                :height="menuH"
                v-bind="attrs"
                tile
                class="toolbar-btn textColor"
                text
                light
                v-on="on"
                :small="$vuetify.breakpoint.xsOnly"
            >
                <v-icon class="mr-1 hidden-xs-only textColor">person</v-icon>
                <div :class="{ mw120p: $vuetify.breakpoint.xsOnly }">{{ UserHeaderValue }}</div>
                <v-icon class="mr-1" v-if="$vuetify.breakpoint.smAndUp">{{ isMenuOpened ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
                <!--                <v-icon class="mr-1" v-if="$vuetify.breakpoint.xsOnly">arrow_right_alt</v-icon>-->
            </v-btn>
        </template>
        <v-list tile class="py-0" id="list" :color="$vuetify.theme.themes.light.primary" :small="$vuetify.breakpoint.xsOnly">
            <v-list-item to="/profile" class="hidden-xs-only text-center font-weight-medium-100">
                <v-list-item-title>{{ $t('Профиль') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logoutFromApplication" class="hidden-xs-only text-center font-weight-medium-100">
                <v-list-item-title>{{ $t('Выйти') }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { mapActions } from 'vuex';
import translate from '@/utils/translate.util';
import { truncate } from '@/utils/';
export default {
    data() {
        return {
            isMenuOpened: false
        };
    },
    methods: {
        ...mapActions('auth', ['logout']),
        async logoutFromApplication() {
            let response = await this.logout();
        }
    },
    computed: {
        menuH() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return '48px';
                case 'sm':
                    return '48px';
                case 'md':
                    return '52px';
                case 'lg':
                    return '52px';
                case 'xl':
                    return '52px';
                default:
                    return '52px';
            }
        },
        loggedIn() {
            return this.$store.getters['auth/loggedIn'];
        },
        servOrgName() {
            return truncate(
                translate(this.$store.state.users.servOrg, 'full', this.$i18n.locale).isas_serv_org_name || this.$store.state.users.servOrg.name,
                20
            );
        },
        UserHeaderValue() {
            return truncate(
                translate(this.$store.state.users.userHeader, 'full', this.$i18n.locale).header_value || this.$store.state.users.userHeader.header_value,
                20
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.small {
    font-size: 10px;
    line-height: 12px;
    padding: 0 8px;
    min-height: 30px;
    align-items: center;
}
</style>
